// src/components/cards/card-short.tsx
import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { IoPlay } from 'react-icons/io5';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const Image = dynamic(import('src/components/image'));

type Props = {
  data: any;
  showTitle?: boolean;
  showPlayIcon?: boolean;
  eventDataLayer?: any;
  showViewProfile?: boolean;
  external?: boolean;
  target?: string;
  type?: 'FEATURE_IMAGE' | 'COVER_IMAGE' | 'CARD_LARGE' | 'CARD_MEDIUM' | 'CARD_SMALL' | 'NEXT_IMAGE' | string;
};

const CardShort = ({ data, showTitle = true, showPlayIcon = true, type, eventDataLayer = {}, showViewProfile = false, external = false, target = '' }: Props) => {
  if (isEmpty(data)) return null;

  return (
    <CardWrapper className='card-short'>
      <a href={data?.link || data?.a || '#'} target={target} onClick={() => sendDataLayerGlobal({ ...eventDataLayer })} aria-label={data?.title}>
        <div className='card-thumb'>
          <Image type={type} image={data?.image || data?.thumbnail} title={data?.title} decorative={Boolean(showTitle)} external={external} />

          {/* Play Icon */}
          {showPlayIcon && (
            <div className='play-icon'>
              <IoPlay />
            </div>
          )}
        </div>

        {/* Title */}
        {showTitle && data?.title && (
          <>
            <div className='card-content'>
              <h3 className='title'>{data?.title}</h3>
              {showViewProfile && <div className='view-portfolio'>View Portfolio</div>}
            </div>
          </>
        )}
      </a>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  position: relative;
  /* border-radius: 8px; */
  overflow: hidden;

  a {
    display: block;
    text-decoration: none;
  }

  &:hover {
    .card-thumb img {
      transform: scale(1.05);
    }

    .play-icon {
      transform: translate(-50%, -50%) scale(1.1);
      background-color: #ed1a3b;
    }

    .title {
      color: #ed1a3b;
      @media (max-width: 768px) {
        color: #ffffff;
      }
    }
  }

  .card-thumb {
    position: relative;
    aspect-ratio: 9 / 16;
    overflow: hidden;
    /* border-radius: 8px; */

    .resolution-image,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    svg {
      font-size: 24px;
      color: #fff;
      margin-left: 3px; /* offset for play icon visual balance */
    }

    @media (max-width: 768px) {
      width: 40px;
      height: 40px;

      svg {
        font-size: 20px;
      }
    }
  }

  .card-content {
    padding: 25px 25px;
    position: absolute;
    bottom: 0;
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%);
    border-radius: 15px;
    width: 100%;
    @media (max-width: 768px) {
      border-radius: 0px;
      padding-bottom: 90px;
      width: 100%;
    }
  }

  .title {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
    transition: color 0.3s ease;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;

    @media (max-width: 768px) {
      font-size: 22px;
    }
  }
  .view-portfolio {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 5px;
    width: fit-content;
    padding: 12px 16px;
    font-size: 14px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    @media (max-width: 768px) {
      background-color: #545454;
      padding: 12px 16px;
      color: #ffffff;
    }
  }
`;

export default CardShort;
